<div [nbSpinner]="loading$ | async">
  <code class="pr-2"> {{ showApi ? (actualKey$ | async) : value }}</code>
  <button nbButton ghost (click)="toggleApiKey()">
    <nb-icon pack="eva" [icon]="showApi ? 'eye-outline' : 'eye-off-outline'"></nb-icon>
  </button>
</div>
